var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
var KtsInformationClaimStatusSelectService = /** @class */ (function (_super) {
    __extends(KtsInformationClaimStatusSelectService, _super);
    function KtsInformationClaimStatusSelectService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    KtsInformationClaimStatusSelectService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsInformationClaimStatusSelectService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsInformationClaimStatusSelectService;
}(ContentBaseService));
export { KtsInformationClaimStatusSelectService };
var InformationTemplate = /** @class */ (function () {
    function InformationTemplate() {
    }
    return InformationTemplate;
}());
export { InformationTemplate };
//# sourceMappingURL=information-claim-status-select.service.js.map